import { useEffect } from 'react'

import { useThemeStore } from '@/stores/app/theme'
import { useUserStore } from '@/stores/app/user'
import { useOrderCreateStore } from '@/stores/orders/create'

export const InitialiseStores = (): null => {
    const initialiseTheme = useThemeStore((state) => state.initialiseTheme)
    const initialiseUser = useUserStore((state) => state.initialiseUser)

    const initialiseOrderCreate = useOrderCreateStore(
        (state) => state.initialiseOrderCreate,
    )

    useEffect(() => {
        const initialisation = async () => {
            initialiseTheme()

            await initialiseUser()

            initialiseOrderCreate()
        }

        initialisation()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null
}
